<template>
    <div class="upload-drop single"
    >
        <div
          v-window-drag-drop="{cb_drop: onFileInlineDrop}"
          class="drop-box"
        >
            <p>
                <i class="far fa-image"></i>
                <span>{{Language.say('editor.drag_image')}}</span>
                <ActionButton
                  icon="fas fa-upload"
                  @click="onOpenFileSelect()"
                  text="editor.pick_images"
                  class="main-action"
                />

                <input
                  @change="onFileSelect"
                  ref="file_select_input"
                  class="hidden"
                  type="file"
                  multiple="multiple"
                  name="file_select"
                >
            </p>
        </div>
    </div>
</template>

<script setup>
  import {ref}                    from 'vue'
  import {defineEmits}            from 'vue'
  import {onMounted, onUnmounted} from 'vue'
  import ActionButton             from '@/vue/Elements/Buttons/ActionButton.vue'
  import Language                 from '@/js/Shared/Language/Language.js';
  import WindowDragController     from '@/js/Webmail/WindowDragController';

  const emit = defineEmits([
    'fileUploadSubmit',
  ])

  const file_select_input = ref();

  onMounted(() => {
    WindowDragController.disable();
  });

  onUnmounted(() => {
    WindowDragController.enable();
  })

  const onOpenFileSelect = () => {
    file_select_input.value.click();
  }

  const onFileSelect = (event) => {
    emit('fileUploadSubmit', event.target);
  }

  const onFileInlineDrop = (event) => {
    emit('fileUploadSubmit', event.dataTransfer);
  }

</script>
